import * as React from 'react';
import { useState, useEffect, useMemo, useCallback } from "react";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { AgGridReact } from 'ag-grid-react';
import { useAdminFilterStore } from 'src/hooks/admin/adminFilter';
import NoResultContent from 'src/pages/HomePageContent/NoResultContent';
import { __remove, __set } from 'src/store/axios_indicator';
import Helper from 'src/support/Helper';
import { useAdminBOMStore } from 'src/hooks/admin/adminBom';
import System from 'src/helper/system';
import usercreated from "src/assets/images/user-create-icon.svg";
import useredit from "src/assets/images/user-edit-icon.svg";
import AdminConsoleHeader from '../AdminConsoleHeader';
import moment from "moment";

let c = System.getParams()

export default function AdminBOMDetails() {
  const [__check] = useAxiosIndicatorCheck();
  const [{ bomList: rowData }, { get_bom_list }, { }] = useAdminBOMStore();
  const [{ filter_list }, { }, { }] = useAdminFilterStore();
  const gridRef = React.useRef();
  // const gridStyle = useMemo(() => ({ height: 700 }), []);
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [agGridFiltered, setAgGridFiltered] = useState(0);

  const [columnDefs, setColumnDefs] = useState([
    {
      field: 'partNumber', pinned: 'left',
      headerName: 'PART NUMBER',
      lockPosition: "left",
      headerTooltip: 'PART NUMBER',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'manufacturerPartNumber',
      pinned: 'left',
      lockPosition: "left",
      headerName: 'MANUFACTURER PART NUMBER',
      headerTooltip: 'MANUFACTURER PART NUMBER',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'customerPartNumber',
      pinned: 'left',
      lockPosition: "left",
      headerName: 'CUSTOMER PART NUMBER',
      headerTooltip: 'CUSTOMER PART NUMBER',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'manufacturer',
      minWidth: 150,
      headerName: 'MANUFACTURER',
      headerTooltip: 'MANUFACTURER',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'description',
      minWidth: 150,
      headerName: 'DESCRIPTION',
      headerTooltip: 'DESCRIPTION',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'quantity',
      minWidth: 150,
      headerName: 'QUANTITY',
      headerTooltip: 'QUANTITY',
      sortable: true,
      comparator: Helper.numberSortingAgGrid
    },
    {
      field: 'matchType',
      minWidth: 130,
      headerName: 'MATCH TYPE',
      headerTooltip: 'MATCH TYPE',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'lifeCycleRisk',
      minWidth: 130,
      headerName: 'LIFE CYCLE RISK',
      headerTooltip: 'LIFE CYCLE RISK',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'designWinFlag',
      minWidth: 130,
      headerName: 'DESIGN WIN FLAG',
      headerTooltip: 'DESIGN WIN FLAG',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'sequenceNumber',
      minWidth: 130,
      headerName: 'SEQUENCE NUMBER',
      headerTooltip: 'SEQUENCE NUMBER',
      sortable: true,
      comparator: Helper.numberSortingAgGrid
    },
    {
      field: 'manualCPN',
      minWidth: 130,
      headerName: 'MANUAL CPN',
      headerTooltip: 'MANUAL CPN',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
    {
      field: 'cpnTypeName',
      minWidth: 130,
      headerName: 'CPN TYPE',
      headerTooltip: 'CPN TYPE',
      sortable: true,
      comparator: Helper.numberSortingAgGrid
    },
    {
      field: 'notes',
      minWidth: 130,
      headerName: 'NOTES',
      headerTooltip: 'NOTES',
      sortable: true,
      comparator: Helper.textSortingAgGrid
    },
  ]);


  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      enableRowGroup: true,
      enableValue: true,
      // lockPinned: true,
      resizable: true
      // suppressMovable: true,
      // menuTabs: ['filterMenuTab', 'columnsMenuTab'],
      // maxWidth: 250
    };
  }, []);

  const fetchAPICall = async () => {
    __set('ADMIN_BOM_API_CALL')

    await get_bom_list(c.bomId)

    __remove('ADMIN_BOM_API_CALL')
  };

  useEffect(() => {
    async function fetchHere() {
      await fetchAPICall()
    }

    fetchHere();
  }, []);


  const onExportAll = async () => {
    const allColumnState = gridColumnApi.getColumnState();
    const customColumns = allColumnState
      .filter((column) => column.hide !== true && column.colId != '0')
      .map((column) => column.colId);
    let params = { fileName: `bom_details.xlsx`, sheetName: "bom_details", columnKeys: customColumns };
    gridRef.current.api.exportDataAsExcel(params);
  }

  const onSelectionChanged = () => {
    setSelectedBomCount(gridRef?.current?.api?.getSelectedRows().length);
  }

  const gridUpdateCallback = (event) => {
    setAgGridFiltered(event.api.getDisplayedRowCount());
  }
  const onColumnResided = (event) => {
    event.columnApi.getColumn('0').setActualWidth(50);
  }

  const onGridReady = (params) => {
    setAgGridFiltered(params.api.getDisplayedRowCount());
    params.api.addEventListener('filterChanged', gridUpdateCallback)
    params.api.addEventListener('filterModified', gridUpdateCallback)
    // params.api.addEventListener('columnResized', onColumnResided);
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  return (
    <div className='adminconsole-container'>
      <AdminConsoleHeader title='BOM DETAILS' />
      <div className='userdetails bg-gray3'>
        <div className='container'>
          <div className="user-details-top">
            <div className="user-details-name  mb-3">
              <h4 className="mt-0">{rowData[0]?.name}</h4>
              <p className="text-black-stone d-flex align-items-center font-arial font-13">BOM ID: {rowData[0]?.id}</p>
            </div>
          </div>
        </div>
        <div className='user-details-bottom'>
          <ul>
            <li>
              <div className="container">
                <div className='user-details-bottom-left'>
                  <i>
                    <img src={useredit} className="me-2" />
                  </i>
                  <div className="d-flex align-items-center"><p className="mb-0 text-black-stone"> Updated on: {moment(rowData[0]?.updatedDate).format('MM/DD/YYYY')} </p> </div>
                </div>
                <div className="text-black-stone user-details-bottom-right">
                  <i>
                    <img src={usercreated} className="me-2" />
                  </i>
                  <div className="d-flex align-items-center"><p className="mb-0 text-black-stone">Created on: {moment(rowData[0]?.createdDate).format('MM/DD/YYYY')}</p> </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className='bg-black p-2'>
        <div className='d-flex align-items-center justify-content-end'>
          <div className='d-flex align-items-center'>
            <span id="emailFilter" className="dropdown me-2">
              <a href={void (0)} data-toggle="dropdown" aria-expanded="false" className='text-white' onClick={onExportAll}>
                <i className="fa fa-download me-1" aria-hidden="true"></i> Export List
              </a>
            </span>
          </div>
        </div>
      </div>

      {__check(['ADMIN_BOM_API_CALL', 'COMMON_API_CALL']).render}
      {!__check(['ADMIN_BOM_API_CALL', 'COMMON_API_CALL']).status &&
        <>
          {rowData?.length > 0 ?
            <div className="ag-theme-alpine ag-grd-hg mb-5">
              <AgGridReact
                ref={gridRef}
                rowData={rowData[0].bomListData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                rowSelection={'multiple'}
                suppressRowClickSelection={true}
                onGridReady={onGridReady}
                onSelectionChanged={onSelectionChanged}
                //  isRowSelectable={isRowSelectable}
                autoGroupColumnDef={{
                  headerName: 'Group',
                  minWidth: 220,
                }}
              >
              </AgGridReact>
            </div> :
            <>
              {filter_list.length > 0 ?
                <div className='container mt-5'>
                  <NoResultContent message={`Sorry! We can't find any results based on your selection.`}
                    isDisplay={false} />
                </div>
                : <div className='d-block pt-5 pb-5 mt-5 mb-5 minh150'></div>
              }
            </>

          }
        </>
      }
    </div>

  );

}
